export const INSERT_GALLERY_BUTTON = 'insert-gallery-button';

export const ROOT = 'gallery-viewer';

export const PLUGIN_TOOLBAR_MANAGE_MEDIA_BUTTON = 'plugin-toolbar-manage-media-button';
export const PLUGIN_TOOLBAR_ADD_MEDIA_BUTTON = 'plugin-toolbar-add-media-button';
export const PLUGIN_TOOLBAR_LAYOUT_DROPDOWN_BUTTON = 'plugin-toolbar-layout-dropdown-button';
export const LAYOUT_SELECTION_DROPDOWN = 'gallery-layout-selection-dropdown';
export const LAYOUT_DROPDOWN_OPTION_CUSTOMIZE_LAYOUT = 'layout-dropdown-option-customize-layout';
export const LAYOUT_DROPDOWN_OPTION = 'layout-dropdown-option-';

export const SETTINGS_MODAL = 'gallery-settings-modal';
export const SETTINGS_TABS = 'settings-tabs';

export const GENERAL_SETTINGS_EXPAND_TOGGLE = 'general-settings-expand-toggle';
export const GENERAL_SETTINGS_DOWNLOAD_TOGGLE = 'general-settings-download-toggle';
export const GENERAL_SETTINGS_SPOILER_TOGGLE = 'general-settings-spoiler-toggle';

export const MEDIA_SETTINGS_SORTABLE_ITEMS = 'media-settings-sortable-items';
export const MEDIA_SETTINGS_DELETE_ITEMS_BUTTON = 'media-settings-delete-items-button';
export const MEDIA_SETTINGS_SELECT_ALL_ITEMS_BUTTON = 'media-settings-select-all-items-button';
export const MEDIA_SETTINGS_DESELECT_ALL_ITEMS_BUTTON = 'media-settings-deselect-all-items-button';
export const MEDIA_SETTINGS_EDIT_ITEM_BUTTON = 'media-settings-edit-item-button';
export const MEDIA_SETTINGS_ADD_MEDIA_INPUT = 'media-settings-add-media-input';
export const MEDIA_SETTINGS_SORTABLE_ITEMS_CONTAINER = 'media-settings-sortable-items-container';

export const MEDIA_ITEM_SETTINGS_DELETE_BUTTON = 'media-item-settings-delete-button';
export const MEDIA_ITEM_SETTINGS_CAROUSEL = 'media-item-settings-carousel';
export const MEDIA_ITEM_SETTINGS_ADD_LINK_BUTTON = 'media-item-settings-add-link-button';
export const MEDIA_ITEM_SETTINGS_ADD_EDIT_LINK_BUTTON = 'media-item-settings-edit-link-button';
export const MEDIA_ITEM_SETTINGS_REPLACE_BUTTON = 'media-item-settings-replace-button';
export const MEDIA_ITEM_SETTINGS_CAPTION_INPUT = 'media-item-settings-caption-input';
export const MEDIA_ITEM_SETTINGS_ALT_INPUT = 'media-item-settings-alt-input';

export const LAYOUT_SETTINGS_LAYOUT_THUMBNAIL_PICKER = 'layout-settings-layout-thumbnail-picker';
export const LAYOUT_SETTINGS_LAYOUT_THUMBNAIL = 'layout-settings-layout-thumbnail-';

export const LAYOUT_SETTINGS_THUMBNAIL_CROP_SEGMENTED_TOGGLE =
  'layout-settings-thumbnail-crop-segmented-toggle';

export const LAYOUT_SETTINGS_IMAGE_ORIENTATION_SEGMENTED_TOGGLE =
  'layout-settings-image-orientation-segmented-toggle';

export const LAYOUT_SETTINGS_SCROLL_DIRECTION_SEGMENTED_TOGGLE =
  'layout-settings-image-scroll-direction-segmented-toggle';

export const LAYOUT_SETTINGS_THUMBNAIL_PLACEMENT_THUMBNAIL_PICKER =
  'layout-settings-thumbnail-placement-thumbnail-picker';
export const LAYOUT_SETTINGS_THUMBNAIL_PLACEMENT_THUMBNAIL =
  'layout-settings-thumbnail-placement-thumbnail-';

export const LAYOUT_SETTINGS_ITEMS_PER_ROW_SLIDER = 'layout-settings-items-per-row-slider';
export const LAYOUT_SETTINGS_ITEMS_PER_ROW_INPUT = 'layout-settings-items-per-row-input';
export const LAYOUT_SETTINGS_THUMBNAIL_SIZE_SLIDER = 'layout-settings-thumbnail-size-slider';
export const LAYOUT_SETTINGS_THUMBNAIL_SIZE_INPUT = 'layout-settings-thumbnail-size-input';
export const LAYOUT_SETTINGS_SPACING_BETWEEN_ITEMS_SLIDER =
  'layout-settings-spacing-between-items-slider';
export const LAYOUT_SETTINGS_SPACING_BETWEEN_ITEMS_INPUT =
  'layout-settings-spacing-between-items-input';
export const LAYOUT_SETTINGS_SPACING_BETWEEN_THUMBNAILS_SLIDER =
  'layout-settings-spacing-between-thumbnails-slider';
export const LAYOUT_SETTINGS_SPACING_BETWEEN_THUMBNAILS_INPUT =
  'layout-settings-spacing-between-thumbnailss-input';

export const LAYOUT_SETTINGS_IMAGE_RATIO_THUMBNAIL_PICKER =
  'layout-settings-image-ratio-thumbnail-picker';
export const LAYOUT_SETTINGS_IMAGE_RATIO_THUMBNAIL = 'layout-settings-image-ratio-thumbnail-';
